const SERVICE = 'market/customer';

const servicelist = async (api, params) => {
  console.log({ params });
  api.setMethod().get().setService(SERVICE).process('/catalogue', params);
};
const packages = async (api, { uuid }) =>
  api
    .setMethod()
    .get()
    .setService(SERVICE)
    .process(`/catalogue/package/${uuid}`);

const productCategory = async (api, params) =>
  // api.setMethod().get().setService(SERVICE).process(`/catalogue`, params);
  api.setService(SERVICE).client.request({
    method: 'GET',
    url: api.service + '/catalogue/',
    params,
    headers: {
      ...api.optionsObject.headers,
    },
  });

const catalogue = async (api) =>
  api
    .setMethod()
    .get()
    .setCamelCaseTransformer(false)
    .setService(SERVICE)
    .process('/catalogue/');

module.exports = {
  servicelist,
  packages,
  catalogue,
  productCategory,
};
